import type { FunctionComponent, PropsWithChildren } from 'react';
import type { State } from 'xstate';

export interface Props {
	state: State<any, any, any, any>;
	stateId?: string;
}

const Route: FunctionComponent<Props> = (props: PropsWithChildren<Props>) => {
	const { state, stateId, children } = props;

	return <>{state?.matches(stateId) ? children : null}</>;
};

export default Route;
